import { render, staticRenderFns } from "./ProvinceListModal.vue?vue&type=template&id=58e963d4&"
import script from "./ProvinceListModal.vue?vue&type=script&lang=js&"
export * from "./ProvinceListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e963d4')) {
      api.createRecord('58e963d4', component.options)
    } else {
      api.reload('58e963d4', component.options)
    }
    module.hot.accept("./ProvinceListModal.vue?vue&type=template&id=58e963d4&", function () {
      api.rerender('58e963d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/ProvinceListModal.vue"
export default component.exports